import type { FC } from "react";

import * as _ from "lodash";

import { i18nFilter } from "app/filters/i18nFilter";
import { numberFilter } from "app/filters/ngFilters";

import type { ITableHeaderCellProps } from "../interfaces/ITableCellProps";

import { SortComponent } from "./DefaultCellHeader";

const getFavIconForSure = (tableData: FixmeType, displayName: string): string => {
    return _.result(
        _.find(tableData, (item) => {
            const favIcon = item[displayName] && item[displayName].Favicon;
            return favIcon && favIcon.length > 0;
        }),
        `[${displayName}].Favicon`,
    );
};

export const LeaderDomainHeaderCell: FC<ITableHeaderCellProps> = (props) => {
    const { sortDirection, tableData, displayName, sortable, showTotalCount, tableMetadata, onSort } = props;
    const i18nDisplayName = i18nFilter()(displayName);
    return (
        <div
            className="headerCell headerCell-leader"
            onClick={(e) => {
                onSort(props);
            }}
        >
            <img
                src={getFavIconForSure(tableData, displayName)}
                alt={displayName}
            />
            <span
                className="headerCell-text"
                title={i18nDisplayName}
            >
                {i18nDisplayName}
            </span>
            {sortable ? <SortComponent sortDirection={sortDirection} /> : null}
            {showTotalCount ? (
                <div className="headerCell-totalCount">{numberFilter()(tableMetadata.totalCount)}</div>
            ) : null}
        </div>
    );
};
LeaderDomainHeaderCell.displayName = "LeaderDomainHeaderCell";
